export enum SearchId {
  FIT_FROM_PRICE = 'FIT_FROM_PRICE',
  FIT_MAIN = 'MAIN_SEARCH'
}
